import { FormattedMessage } from 'react-intl'
import { SummaryRow } from 'ui'
import { RegularBenefit } from '../../../../../typings'
import { useGenericComponent } from '../../../../promotions/RegularForm/RegularEffect/hooks/useGenericComponent'
import { REVIEW_MAP } from './constants'
import { messages } from './messages'

type Props = {
  benefit: RegularBenefit | undefined
}

export function RegularRow(props: Props) {
  const { benefit } = props

  const { GenericComponent } = useGenericComponent({
    settings: REVIEW_MAP,
    type: benefit?.type,
  })

  if (!benefit) return null

  return (
    <>
      <SummaryRow>
        <SummaryRow.Title>
          <FormattedMessage {...messages.title} />
        </SummaryRow.Title>
        <GenericComponent config={benefit} />
      </SummaryRow>
    </>
  )
}
